//@ts-check
import { View } from '@adobe/react-spectrum';
import React from 'react';

/** @param { import('@adobe/react-spectrum').ViewProps} props */
const DetailsSectionView = (props) => (
  <View
    backgroundColor="static-white"
    borderRadius="regular"
    borderColor="gray-200"
    borderWidth="thin"
    padding={{ base: 'size-200', L: 'size-400' }}
    {...props}
  />
);

export default DetailsSectionView;
